import '@fontsource/roboto/latin-400.css';
import '@fontsource/roboto/latin-500.css';
import '@fontsource/roboto/latin-700.css';
import './index.css';

import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import * as Sentry from '@sentry/react';
import React from 'react';
import ReactDOM from 'react-dom/client';

import App from './App';

const sentryDsn = import.meta.env['REACT_APP_SENTRY_DSN'];

Sentry.init({
  enabled: sentryDsn !== undefined,
  dsn: sentryDsn,
  // Prevent Sentry from truncating the error message
  maxValueLength: 1500,
});

export const msalConfig = {
  auth: {
    clientId: import.meta.env['REACT_APP_MICROSOFT_CLIENT_ID']!,
    authority: 'https://login.microsoftonline.com/common/v2.0',
    redirectUri: import.meta.env['REACT_APP_MICROSOFT_LANDING_ENDPOINT']!,
  },
  cache: {
    cacheLocation: 'sessionStorage', // This configures where your cache will be stored
    storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
  },
  system: {},
};

const msalInstance = new PublicClientApplication(msalConfig);
const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <React.StrictMode>
    <MsalProvider instance={msalInstance}>
      <App />
    </MsalProvider>
  </React.StrictMode>,
);
